import React, { Component } from "react";
import PageContent from "@my-dld/components/PageContent";
import Strings from "@my-dld/assets/strings";
import FormSection from "@my-dld/components/Form/FormSection";
import TextInputField from "@eres/forms-web/TextInputField";
import { WebFormFieldProps } from "@eres/forms-web";
import StateHolder from "@eres/forms/StateHolder";
import { defaultErrorManager } from "@eres/forms/errormanager";
import { ErrorContainer } from "@eres/forms";
import { checkNonEmpty } from "@eres/ejari-web/utils";
import { hideLoading, showLoading, showMessage } from "@my-dld/utils/UIUtils";
import { privateSellApi } from "../../../apis/privatesell";
import { trackEventWithData } from "@my-dld/utils/Analytics";
import { PSRole, PvtSellRequest, PvtSellResponse } from "../../../apis/privatesell/enitites";
import VerifyOTP from "./Verify";
import { JQModal } from "@my-dld/components/Popup/Utils";
import { navigate } from "@my-dld/utils/StoreUtils";
import { getParentFullPath } from "@my-dld/utils/PathUtils";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { IdentityApi } from "@10x/dubai-rest-api";

interface Props extends RoutedViewProps {

}

interface State {
	bookingRef?: string;
	mobile?: string;
	email?: string;
	otpCode?: string;
	apiResponse?: PvtSellResponse;
	errorContainer: ErrorContainer;
}

export default class SearchByBookingRef extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			errorContainer: {},
		};
	}

	render() {
		const { bookingRef, mobile, email, otpCode } = this.state;
		const filedProps: Partial<WebFormFieldProps<any, any>> = {
			holder: StateHolder.buildStateHolder( this ),
			errorManager: defaultErrorManager,
		};
        return <>
            <div className="container">
                <div className="col-md-12">
                    <div className="alert alert-warning">{Strings.booking_request_desc}</div>
                </div>
                <TextInputField
                    {...filedProps}
                    id={"bookingRef"}
                    required={true}
                    containerClassName="col-md-4"
                    label={Strings.booking_ref_number}
                />
                <div className="col-md-12 mt-3">
					<button
						className="btn btn_1 btn_style1" data-bs-target="#buyerOTPVerification"
						data-bs-toggle="modal" onClick={ this.onContinue }>{ Strings.continue }
					</button>
					<button className="btn btn-grey btn_style1 ms-2 me-2" onClick={ this.onReset }>{ Strings.reset }</button>
				</div>
			</div>
			{
				mobile && email && <VerifyOTP
					mobile={ mobile }
					email={ email }
					referenceNumber={ bookingRef! }
					otpCode={ otpCode }
					onResend={ () => {
						if ( this.state.apiResponse )
							this.onGenerateOTP( this.state.apiResponse, true );
					} }
					onConfirmed={ this.onConfirmed } onCancel={ this.onCancel }/>
			}
		</>;
	}

	onCancel = () => {
		JQModal( "verify-pop" ).hide();
	};
	onConfirmed = () => {
		JQModal( "verify-pop" ).hide();
		const currentPath = getParentFullPath( this.props.location.pathname, "/" );
		navigate( currentPath + `/${ this.state.bookingRef }`,
			undefined, {
				result: this.state.apiResponse,
				role: PSRole.BUYER,
			} );
	};

	onGenerateOTP = ( apiResponse: PvtSellResponse, isResend: boolean ) => {
		let transaction: PvtSellRequest = apiResponse.request;
		if ( transaction ) {
			privateSellApi.generateToken( this.state.bookingRef! ).then( response => {
				hideLoading();
				let mobile = transaction.bookingRequestInfo!.buyerInfo?.mobile;
				let email = transaction.bookingRequestInfo!.buyerInfo?.email;
				let otpCode = response.otpCode;
				this.setState( { mobile: mobile, email: email, otpCode: otpCode, apiResponse: apiResponse }, () => {
					if ( !isResend ) {
						JQModal( "verify-pop" ).show();
					}
				} );
			} ).catch( ex => {
				hideLoading();
			} );
		} else {
			hideLoading();
		}
	};
	onContinue = () => {
		let isValid = true;
		let errorView: ErrorContainer = {};
		isValid = checkNonEmpty( this.state, "bookingRef", errorView ) && isValid;
		this.setState( { errorContainer: errorView } );
		if ( isValid ) {
			showLoading();
			const apiHandler = ( apiResponse: any ) => {
				if ( apiResponse ) {
					trackEventWithData( "PrivateSell", "SearchRequest", { bookingRef: this.state.bookingRef } );
					this.onGenerateOTP( apiResponse, false );
				} else {
					hideLoading();
				}
			};
			let exHandler = ( reason: any ) => {
				hideLoading();
				if ( reason && reason.type && reason.type === "ValidationError" ) {
					showMessage( Strings.system_error + "\n" + reason.message );
					trackEventWithData( "PrivateSell", "SearchRequestFailed",
						{ bookingRef: this.state.bookingRef, error: Strings.system_error + "-" + reason.message } );
				} else {
					showMessage( reason.toString() );
					trackEventWithData( "PrivateSell", "SearchRequestFailed",
						{ bookingRef: this.state.bookingRef, error: reason.toString() } );
				}
			};
			IdentityApi.guestAuthenticate().then( () => {
				privateSellApi.getSellRequestByRef( this.state.bookingRef! ).then( apiHandler ).catch( exHandler );
			} ).catch( () => {
				hideLoading();
			} );
		}
	};

	onReset = () => {
		this.setState( { bookingRef: "" } );
	};
}
